export const withCustomParams = (Component, customParams) => {
  return props => <Component {...props} {...customParams} />;
};
